import { createFileRoute } from '@tanstack/react-router';

/**
 * EB Search Index Route Definition
 * Component is loaded from index.lazy.tsx for automatic code splitting
 * Note: Auth is handled by parent _protected route
 */
export const Route = createFileRoute('/_protected/eb/')({});
